<template>
  <div class="article-view-appointment-form">
    <div class="app-basic-layout-wrapper">
      <h3 class="title font-30">预约顾问咨询</h3>
      <div class="contact-info">
        <div class="font-16">或者直接拨打</div>
        <div class="line"></div>
        <div class="phone-num font-42">400-097-0970</div>
        <div class="tips font-14 font-color-desc">
          周一至周五 9:00-18:00（仅收市话费）
        </div>
        <div class="email font-20">Email：smc@staff.weibo.com</div>
      </div>
      <div class="form-wrapper">
        <el-form
          ref="form"
          inline
          :model="form"
          :rules="rules"
          class="appointment-form"
        >
          <el-form-item prop="company">
            <el-input
              v-model="form.company"
              class="form-input"
              placeholder="公司名称（必填）"
            ></el-input>
          </el-form-item>
          <el-form-item prop="name">
            <el-input
              v-model="form.name"
              class="form-input"
              placeholder="姓名（必填）"
            ></el-input>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input
              v-model.number="form.phone"
              class="form-input"
              placeholder="电话（必填）"
              maxlength="11"
            ></el-input>
          </el-form-item>
          <el-form-item prop="email">
            <el-input
              v-model="form.email"
              class="form-input"
              placeholder="邮箱（必填）"
            ></el-input>
          </el-form-item>
        </el-form>
        <button class="submit-btn" :disabled="isSubmitting" @click="onSubmit">
          立即预约咨询
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { THIRD_API } from '@/global/config'

export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      if (/^1\d{10}$/.test(value)) {
        callback()
      } else {
        callback(new Error('手机号码格式错误'))
      }
    }
    return {
      form: {
        company: '',
        name: '',
        phone: '',
        email: '',
        from: 'article'
      },
      rules: {
        company: [{ required: true, message: '请填写公司名称！' }],
        name: [{ required: true, message: '请填写您的姓名！' }],
        email: [
          {
            type: 'email',
            required: true,
            message: '请填写您的正确邮箱地址！',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: 'blur',
            type: 'phone'
          }
        ]
      },
      isSubmitting: false
    }
  },
  methods: {
    onSubmit() {
      this.isSubmitting = true
      this.$nextTick(() => {
        this.$refs.form.validate(async valid => {
          if (valid) {
            try {
              await this.$http.post(
                THIRD_API.alkSubmitConsult.link,
                {
                  data: {
                    product_id: this.$route.query.id || this.$route.params.id,
                    ...this.form
                  }
                },
                true
              )
              this.isSubmitting = false
              Message.success('预约成功！')
            } catch ({ error }) {
              Message.error(error)
              this.isSubmitting = false
            }
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.article-view-appointment-form {
  background-color: #f4f5f7;
  padding: 64px 0 108px;
  .title {
    text-align: center;
    line-height: normal;
    position: relative;
    margin-bottom: 83px;
    &:after {
      content: '';
      height: 5px;
      width: 25px;
      position: absolute;
      background-color: #f8653f;
      border-radius: 2.5px;
      bottom: -30px;
      left: 50%;
      margin-left: -12.5px;
    }
  }
  .contact-info {
    float: right;
    text-align: right;
    .line {
      display: block;
      margin: 8px 0 16px;
      &:after {
        content: '';
        float: right;
        width: 64px;
        height: 4px;
        background-color: #3352fe;
        border-radius: 2px;
      }
    }
    .tips {
      margin-bottom: 6px;
    }
  }
  .form-wrapper {
    overflow: hidden;
    padding: 0 69px 0 0;
    .el-form-item {
      float: left;
      width: calc(50% - 28px);
      margin: 0 28px 40px 0;
    }
  }
  .submit-btn {
    width: 100%;
    padding: 0 5em;
    height: 48px;
    text-align: center;
    color: #ffffff;
    background-color: #3352fe;
    border: none;
    outline: none;
    cursor: pointer;
    border-radius: 24px;
    white-space: nowrap;
    margin-top: 10px;
  }
}
</style>

<style lang="scss">
.article-view-appointment-form {
  .el-form-item__content {
    width: 100%;
  }
  .el-input__inner {
    border-radius: 26px;
    font-size: 16px;
    border-color: #f4f5f7;
    background-color: #ffffff;
    color: #363636;
    padding: 0 20px;
    height: 52px;
    line-height: 52px;
    &::placeholder {
      font-size: 13px;
      color: #8e9091;
    }
    &:focus {
      &,
      & + .el-input-group__append {
        border-color: #3352fe;
      }
    }
  }
  .el-form-item.is-error {
    .el-input-group__append {
      border-color: #f8653f;
    }
  }
}
</style>
